// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import { Link } from 'react-router-dom';
import { useLocale } from '../../hooks/useLocale.js';
import { usePageTitle } from '../../hooks/usePageTitle.js';

export function AccessDeniedPage() {
  const { t } = useLocale();
  usePageTitle(t.common.access_denied);

  return (
    <div className="dm-page dm-access-denied" data-testid="access-denied">
      <div className="dm-access-denied-card">
        <h1>{t.common.access_denied}</h1>
        <p>{t.common.no_permission}</p>
        <Link to="/admin" className="dm-btn dm-btn-primary">
          {t.common.back_to_dashboard}
        </Link>
      </div>
    </div>
  );
}
